import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClearService {

  subject = new Subject<any>();

  constructor() { }

  notify(operate: () => void, msg?: string) {
    this.subject.next({ operate, msg });
  }

  toggle(): Observable<any> {
    return this.subject.asObservable();
  }

}
